import api from '../api'
export default {
  namespaced: true,
  state: {
    projectList: [],
    projectTotal: '',
    projectDetail: ''
  },
  mutations: {
    GET_PROJECT_LIST (state, data = {}) {
      state.projectList = data.records || []
      state.projectTotal = data.total
    },
    GET_PROJECT_DETAIL (state, data) {
      state.projectDetail = data
    }
  },
  actions: {
    GET_PROJECT_LIST ({ commit, dispatch }, config) {
      return api.projectList(config).then((res) => {
        commit('GET_PROJECT_LIST', res.payload)
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    },
    GET_PROJECT_DETAIL ({ commit, dispatch }, config) {
      return api.projectDetail(config).then((res) => {
        commit('GET_PROJECT_DETAIL', res.payload)
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    },
    DELETE_PROJECT ({ commit, dispatch }, params) {
      return api.deleteproject({
        params: params
      }).then((res) => {
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    },
    ADD_PROJECT ({ commit, dispatch }, config) {
      return api.addproject(config).then((res) => {
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    },
    UPDATE_PROJECT ({ commit, dispatch }, config) {
      return api.updateproject(config).then((res) => {
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/medicalProjectManage/store/index.js